window.addEventListener("DOMContentLoaded", () => {
  const interval = setInterval(() => {
    const overlay = document.getElementById(
      "webpack-dev-server-client-overlay"
    );
    if (overlay) {
      overlay.remove();
      clearInterval(interval);
    }
  }, 100);
});

// Disable React refresh overlay
window.__REACT_ERROR_OVERLAY_GLOBAL_HANDLER__ = function () {};
